import { ApolloClient, InMemoryCache } from "@apollo/client";
import Cookies from "js-cookie";

export const apolloClient = new ApolloClient({
    uri: "/patient-app/api/graphql/",
    cache: new InMemoryCache(),
    headers: { "X-CSRFToken": Cookies.get("csrftoken") || "" },
});
